import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class SalaryRow extends Component {
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Sorszám</TableCell>
                            <TableCell>Munkavállaló</TableCell>
                            <TableCell>Év</TableCell>
                            <TableCell>Hónap</TableCell>
                            <TableCell>Nettó fizetés</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell> {this.props.row.publicId}</TableCell>
                            <TableCell>{this.props.row.employeeName}</TableCell>
                            <TableCell>{this.props.row.year}</TableCell>
                            <TableCell>{this.props.row.month}</TableCell>
                            <TableCell>{this.props.row.netSalary}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default SalaryRow;